const SDK_VERSION = "10.67.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
